import React from 'react';
import { formatShowWallTime, showWallTimeCandidates } from '../../domain/showPeriodTime';

/** Resolve location wall time explicitly, including missing/repeated DST times. */
export default function LocationDateTimeInput({ label, value, timezone, disabled = false, onChange }: {
  label: string; value: string; timezone: string; disabled?: boolean; onChange: (instant: string) => void;
}) {
  const [wall, setWall] = React.useState(() => value ? formatShowWallTime(value, timezone).slice(0, 16) : '');
  const [choices, setChoices] = React.useState<string[]>([]);
  const [error, setError] = React.useState('');
  const lastEmitted = React.useRef(value);
  const lastTimezone = React.useRef(timezone);
  React.useEffect(() => {
    if (value !== lastEmitted.current || timezone !== lastTimezone.current) { setWall(value ? formatShowWallTime(value, timezone).slice(0, 16) : ''); setChoices([]); setError(''); }
    lastEmitted.current = value; lastTimezone.current = timezone;
  }, [value, timezone]);
  function choose(instant: string) { lastEmitted.current = instant; onChange(instant); }
  function change(next: string) {
    setWall(next);
    try {
      const matches = next ? showWallTimeCandidates(next, timezone) : [];
      setChoices(matches);
      if (matches.length === 1) { setError(''); choose(matches[0]); }
      else { choose(''); setError(!next ? '' : matches.length ? 'Choose which occurrence of this local time.' : 'This time is skipped when the clocks move forward.'); }
    } catch (caught) { choose(''); setChoices([]); setError(caught instanceof Error ? caught.message : 'Choose a valid local time.'); }
  }
  return <label className="admin-service-field"><span>{label}</span>
    <input type="datetime-local" value={wall} onChange={event => change(event.target.value)} disabled={disabled} aria-invalid={Boolean(error)} />
    {choices.length > 1 ? <select key={wall} aria-label={`${label} clock occurrence`} disabled={disabled} defaultValue="" onChange={event => {
      if (event.target.value) { choose(event.target.value); setError(''); }
    }}><option value="" disabled>Choose occurrence</option>{choices.map((instant, index) => <option key={instant} value={instant}>
      {index === 0 ? 'Earlier' : 'Later'} ({new Intl.DateTimeFormat(undefined, { timeZone: timezone, timeZoneName: 'short' }).format(new Date(instant))})
    </option>)}</select> : null}
    {error ? <small role="alert">{error}</small> : null}
  </label>;
}
